import React from 'react';
import JoinMerchantView from './join-merchant.view';

const JoinMerchant: React.FC = () => {
  return <JoinMerchantView />;
};

export default JoinMerchant;
